import React, { useState, useEffect } from "react";

import { Table, Space, Button, Popconfirm } from "antd";

import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";

import {
  CampoBuscaInstantanea,
  destacarBusca,
  useBuscaInstantanea,
} from "../../../../components/CampoBuscaInstantanea";
import { SecaoCard } from "../../../../components/SecaoCard";

import { openNotification } from "../../../../components/Notification";
import { tipoViolacaoService } from "../../../../services";
import { useHistory } from "react-router-dom";
import { urls } from "../../../../utils";

const ListTipos = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [tiposDenuncia, setTiposDenuncia] = useState([]);
  const { busca, onChangeBusca, filtrados, paginacaoBusca } =
    useBuscaInstantanea(tiposDenuncia, ["descricao"]);

  const getDenunciationTypes = async (codigoTema) => {
    setLoading(true);
    await tipoViolacaoService
      .loadViolationTypes({ codigoTema })
      .then((response) => setTiposDenuncia(response.data))
      .catch((reason) =>
        openNotification(
          "error",
          <strong>Erro!</strong>,
          "Ocorreu um erro ao buscar os Tipos de Denúncia."
        )
      );
    setLoading(false);
  };

  const handleDeleteTipo = async (codigo) => {
    try {
      await tipoViolacaoService.deleteViolationType(codigo);
      openNotification("success", <strong>Tipo excluído com sucesso!</strong>);
      getDenunciationTypes();
    } catch (reason) {
      openNotification(
        "error",
        <strong>Não foi possível excluir o tipo!</strong>,
        "Erro: " + reason.response.data.userMessage
      );
    } finally {
    }
  };

  useEffect(() => {
    getDenunciationTypes();
  }, []);

  const renderTable = () => {
    const columns = [
      {
        title: <strong>descrição</strong>,
        dataIndex: "descricao",
        key: "descricao",
        render: (descricao) => destacarBusca(descricao, busca),
      },
      {
        title: <strong>ações</strong>,
        key: "action",
        width: 64,
        render: ({ codigo, descricao }) => (
          <Space size="small">
            <Button
              type="primary"
              className="action-button"
              title={`Editar agravante ${descricao}`}
              onClick={() =>
                history.push(
                  urls.CLASSIFICACOES_TIPO_DETAILS.replace(":codigo", codigo)
                )
              }
            >
              <EditOutlined style={{ fontSize: "1.2rem" }} />
            </Button>
            <div>
              <Popconfirm
                title={
                  <span>
                    excluir tipo: <strong>{descricao}</strong>?"
                  </span>
                }
                placement="bottomRight"
                okText="confirmar exclusão"
                cancelText="cancelar"
                icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                onConfirm={() => handleDeleteTipo(codigo)}
              >
                <Button type="danger" className="action-button">
                  <DeleteOutlined style={{ fontSize: "1.2rem" }} />
                </Button>
              </Popconfirm>
            </div>
          </Space>
        ),
      },
    ];
    function showTotal(total) {
      return (
        <>
          Total de <strong>{total}</strong> tipos
        </>
      );
    }
    return (
      <Table
        loading={loading}
        dataSource={filtrados}
        columns={columns}
        size="small"
        rowKey={({ codigo }) => codigo}
        pagination={{
          ...paginacaoBusca,
          showTotal: showTotal,
        }}
      />
    );
  };

  return (
    <>
      <div className="container-section">
        <div id="header-container">
          <h2>LISTA DE TIPOS</h2>
          <div id="header-actions">
            <Button
              type="primary"
              onClick={() =>
                history.push(
                  urls.CLASSIFICACOES_TIPO_CRIAR.replace("/:codigo", "")
                )
              }
            >
              novo tipo
            </Button>
          </div>
        </div>
        <SecaoCard>
        <CampoBuscaInstantanea
          value={busca}
          onChange={onChangeBusca}
          placeholder="Busque pelo tipo"
        />
        {renderTable()}
        </SecaoCard>
      </div>
    </>
  );
};

export default ListTipos;
